import React, { useEffect, useRef, useState } from 'react';
import '@google/model-viewer/dist/model-viewer';
import arimg from "../assets/2.png";
import './Viewer.css'; // استایل‌ها رو اینجا تعریف کن یا داخل همین فایل بنویس

export default function Viewer() {
    const modelViewer = useRef();
    const [arActive, setArActive] = useState(false);
    const [chooseDevice, setChooseDevice] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // شناسایی نوع دستگاه
        if (navigator.userAgent.match(/Android/i)) {
            setChooseDevice('Android');
        } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            setChooseDevice('iPhone');
        } else {
            setChooseDevice('desktop');
        }
    }, []);

   
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          console.log('User entered Quick Look or switched tab — save state or pause animations.');
        } else if (document.visibilityState === 'visible') {
          console.log('User returned from Quick Look — cleanup or reinitialize here.');
          cleanupAR()
          // آزادسازی حافظه یا ریست برای تست مجدد
        }
      });
   
    useEffect(() => {

        if (modelViewer.current) {
            modelViewer.current.addEventListener('load', () => {
                console.log('load')
                setIsLoading(false);
            });

            // اختیاری: مشاهده درصد پیشرفت
            modelViewer.current.addEventListener('progress', (event) => {
                const percent = Math.round(event.detail.totalProgress * 100);
                setProgress(percent);
                console.log('progress()...')

                console.log("در حال بارگذاری:", Math.round(event.detail.totalProgress * 100) + "%");
            });
            // modelViewer.current.addEventListener('ar-status', handleARStatus);
            // modelViewer.current.addEventListener('quick-look-button-tapped', handleARStatus);
            // modelViewer.current.addEventListener('quick-look', handleARStatus);


        }

        // پاکسازی
        return () => {
            if (modelViewer.current) {
                modelViewer.current.removeEventListener('load', () => { });
                modelViewer.current.removeEventListener('progress', () => { });

            }
        };
    }, []);

    const Vepod = ['model/Vepod_03.glb'];
    const VepodUSDZ = ['model/Vepod_03.usdz'];
    const [model] = useState(Vepod[0]);

    const OpenAR = () => {
        document.getElementById("ar-button").click();
    };


  // پاک‌سازی منابع
  function cleanupAR() {
    // 1. متوقف کردن انیمیشن‌ها (اگر وجود دارد)
    if (modelViewer.current.ticking) {
      modelViewer.current.cancelAnimation();
    }

    // 2. پاک‌سازی مدل
    // modelViewer.current.model = null;

    // 3. ریست کردن دوربین
    // modelViewer.current.cameraOrbit = "0deg 75deg 105%";
    // modelViewer.current.cameraTarget = "0m 0m 0m";

    // 4. آزاد کردن WebGL منابع (در صورت دسترسی)
    if (modelViewer.current.renderer) {
      const renderer = modelViewer.current.renderer;
      renderer.dispose(); // در برخی نسخه‌ها پشتیبانی می‌شود
    }
   


    console.log("حافظه پاک‌سازی شد!");
  }

    return (
        <div className="viewer-container">
            {isLoading && (
                <div id="custom-loader">
                    <div className="spinner-wrapper">
                        <div className="spinner"></div>
                        <p className="loading-text">{progress}%</p>
                    </div>
                </div>
            )}

            <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
                <model-viewer
                   ref={modelViewer}
                    id="model"
                    src={model}
                    ios-src={VepodUSDZ[0]}
                    shadow-intensity="1"
                    camera-controls
                    environment-image="christmas_photo_studio_07_1k.hdr"
                    touch-action="pan-y"
                    // loading="eager"
                    loading="lazy"
                    ar
                    ar-modes="scene-viewer quick-look webxr"

                >
                    <button slot="ar-button" id="ar-button"></button>
                </model-viewer>

                <div className="panelTop" id="panelTop">
                    <div className="img">
                        {chooseDevice === 'desktop' ? (
                            <h2>جهت مشاهده سه بعدی در محیط از تلفن همراه خود استفاده کنید</h2>
                        ) : (
                            <div className="ar-button-container">
                            <img 
                              src={arimg} 
                              onClick={OpenAR} 
                              alt="AR Button" 
                              className="ar-button" 
                            />
                          </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
